export enum ConvergeEnv {
  Development = 'development',
  Test = 'test',
  Local = 'local',
  Production = 'production',
  Staging = 'staging',
  Qa = 'qa',
}

export const DEFAULT_CONVERGE_ENVIRONMENT = ConvergeEnv.Local;

export const CONVERGE_UUID = '4ce33334-f0aa-4caf-b79c-e33b21e581fb';

export enum SubmissionStatus {
  Submitted = 'SUBMITTED',
  Cleared = 'CLEARED',
  Declined = 'DECLINED',
  Lost = 'LOST',
  Indicated = 'INDICATED',
  RequestedMoreInfo = 'REQUESTED_MORE_INFO',
  Evaluation = 'EVALUATION',
  Quoted = 'QUOTED',
  Hold = 'HOLD',
  Bound = 'BOUND',
  PolicyIssued = 'POLICY_ISSUED',
  Closed = 'CLOSED',
  Referred = 'REFERRED',
  Cancelled = 'CANCELLED',
  PendingCancellation = 'PENDING_CANCELLATION',
}

export enum UnderwritingSubmissionType {
  Primary = 'PRIMARY',
  Excess = 'EXCESS',
}

export enum Tenant {
  AffinityAdvisors = 'AFFINITY_ADVISORS',
  Converge = 'CONVERGE',
  Herald = 'HERALD',
  Limit = 'LIMIT',
  Mshift = 'MSHIFT',
  RtSpecialty = 'RT_SPECIALTY',
}

export enum SubmissionType {
  newBusiness = 'New Business',
  renewal = 'Renewal',
}

export enum CreateSubmissionField {
  LegalName = 'legalName',
  TradingName = 'tradingName',
  Domain = 'domain',
  Street1 = 'street1',
  Street2 = 'street2',
  City = 'city',
  RegionUuid = 'regionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'countryUuid',
  ContactFirstName = 'contactFirstName',
  ContactLastName = 'contactLastName',
  ContactEmailAddress = 'contactEmailAddress',
  ContactPhoneNumber = 'contactPhoneNumber',
  CurrentDomesticRevenue = 'annualRevenue',
  EstablishedYear = 'yearEstablished',
  ProjectDomesticRevenue = 'projectedRevenue',
  CurrentForeignRevenue = 'foreignRevenue',
  ProjectForeignRevenue = 'projectedForeignRevenue',
  RatedRevenueOverride = 'ratedRevenueOverride',
  NumEmployees = 'numEmployees',
  IndustrySector = 'industrySector',
  //Brokerage
  BrokerageUuid = 'brokerUuid',
  BrokerAgentUuid = 'brokerAgentUuid',
  BrokerStreet1 = 'brokerStreet1',
  BrokerStreet2 = 'brokerStreet2',
  BrokerCity = 'brokerCity',
  BrokerRegionUuid = 'brokerRegionUuid',
  BrokerPostalCode = 'brokerPostalCode',
  BrokerCountryUuid = 'brokerCountryUuid',
  BrokerPhoneNumber = 'brokerPhoneNumber',
  BrokerEmailAddress = 'brokerEmailAddress',
  Designation = 'designation',
  //Requested Policy
  ProductType = 'productType',
  ProgramUuid = 'program',
  Type = 'type',
  PartnerUuid = 'partner',

  AggregateLimit = 'aggregateLimit',
  PolicyRetention = 'policyRetention',
  PolicyStartDate = 'policyStartDate',
  PolicyEndDate = 'policyEndDate',
  PolicyRetroactiveDate = 'policyRetroactiveDate',
  //Submission
  ReceivedAt = 'receivedAt',
  ReceivedBy = 'receivedBy',
  DueDate = 'dueDate',
  Notes = 'notes',
  //Other
  ClearanceNote = 'clearanceNote',
  ClearanceStatus = 'clearanceStatus',
  Status = 'status',
  Attachments = 'attachments',
  UserUuid = 'userUuid',
}

export enum CreateClaimNoteField {
  Note = 'note',
  Attachments = 'attachments',
  Categories = 'categories',
  Folder = 'folder',
}

export enum CreateSubjectivityField {
  customSubjectivityNameField = 'customSubjectivityField',
}
export enum CreateBrokerageField {
  BusinessDevelopmentManager = 'bdmUserUuid',
  Underwriter = 'underwriterUserUuid',
  UwRegion = 'uwTerritoryUuids',
  BdmRegion = 'bdmTerritoryUuids',
  PrimaryContactUuid = 'primaryPersonUuid',
  PrimaryContactEmail = 'PrimaryContactEmail',
  CompanyName = 'companyName',
  DbaName = 'dbaName',
  Domain = 'domain',
  GlobalParentCompany = 'globalParentCompany',
  PartnerEntity = 'partnerEntity',
  Fein = 'fein',
  Npn = 'npn',
  ProgramUuid = 'programUuid',
  CoverageRegionUuid = 'convergeRegion',
  PrimaryStreet1 = 'primaryStreet1',
  PrimaryStreet2 = 'primaryStreet2',
  PrimaryCity = 'primaryCity',
  PrimaryRegionUuid = 'primaryRegionUuid',
  PrimaryPostalCode = 'primaryPostalCode',
  PrimaryCountryUuid = 'primaryCountryUuid',
  Street1 = 'street1',
  Street2 = 'street2',
  City = 'city',
  RegionUuid = 'RegionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'countryUuid',
  PrimaryPhoneNumber = 'primaryPhoneNumber',
  PrimaryPhoneNumberExtn = 'primaryPhoneNumberExtn',
  Wholesale = 'wholesale',
  Digital = 'digital',
}

export enum CreateLicenseField {
  LicenseHolderUuid = 'licenseHolderUuid',
  Uuid = 'uuid',
  LicenseTypeUuid = 'licenseTypeUuid',
  LicenseNumber = 'licenseNumber',
  LicenseRegionUuid = 'licenseRegionUuid',
  LicenseExpirationDate = 'licenseExpirationDate',
  perpetual = 'perpetual',
}

export enum CreateClaimantField {
  FirstName = 'firstName',
  LastName = 'lastName',
  CompanyName = 'companyName',
  Email = 'email',
  PrimaryPhoneNumber = 'primaryPhoneNumber',
  PrimaryPhoneNumberExtn = 'primaryPhoneNumberExtn',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  RegionUuid = 'regionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'countryUuid',
  isInsured = 'isInsured',
}
export enum CreateOfficeField {
  BusinessDevelopmentManager = 'bdmUserUuid',
  Underwriter = 'underwriterUserUuid',
  UwRegion = 'uwTerritoryUuids',
  PrimaryContactUuid = 'primaryPersonUuid',
  PrimaryContactEmail = 'primaryContactEmail',
  AddressUuid = 'addressUuid',
  Name = 'name',
  OfficeUuid = 'officeUuid',
  UwTerritoryUuids = 'uwTerritoryUuids',
  AppendUwTerritories = 'appendUwTerritories',
  Street1 = 'street1',
  Street2 = 'street2',
  City = 'city',
  RegionUuid = 'regionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'countryUuid',
  useCorpAddress = 'useCorpAddress',
  BdmTerritoryUuids = 'bdmTerritoryUuids',
}
export enum CreateTeamsField {
  BusinessDevelopmentManager = 'bdmUserUuid',
  BDMRegion = 'bdmTerritoryUuid',
  Underwriter = 'underwriterUserUuid',
  PrimaryContactUuid = 'personUuid',
  TeamName = 'teamName',
  UwRegion = 'uwRegion',
  PrimaryContact = 'primaryContact',
  PrimaryContactEmail = 'primaryContactEmail',
  Uuid = 'uuid',
}

export enum CreateRecoveryField {
  RecoveryType = 'recoveryTypeUuid',
  AmountAnticipated = 'amountAnticipated',
}

export enum CreateSubsidiaryField {
  LegalName = 'legalName',
  DbaName = 'dbaName',
  Domain = 'domain',
  Fein = 'fein',
  Npn = 'npn',
  ProgramUuid = 'program',
  Region = 'region',
  OfficeName = 'officeName',
  BrokerTeamName = 'brokerTeamName',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  RegionUuid = 'globalBrokerageRegionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'CountryUuid',
  PrimaryContactFirstName = 'primaryContactFirstName',
  PrimaryContactLastName = 'primaryContactLastName',
  Email = 'email',
  MobilePhoneNumber = 'mobilePhone',
  OfficePhoneNumber = 'officeHome',
}
export enum CreateBrokerField {
  BusinessDevelopmentManager = 'bdmUserUuid',
  Underwriter = 'underwriterUserUuid',
  UwRegion = 'uwTerritoryUuids',
  BdmRegion = 'bdmTerritoryUuids',
  FirstName = 'firstName',
  LastName = 'lastName',
  Ssn = 'ssn',
  Npn = 'entityNpn',
  GlobalParent = 'globalParent',
  Office = 'office',
  BrokerTeam = 'brokerTeam',
  Email = 'email',
  SecondaryEmail = 'secondaryEmail',
  TertiaryEmail = 'tertiaryEmail',
  MobilePhoneNumber = 'mobileNumber',
  MobilePhoneNumberExtn = 'mobileNumberExtn',
  OfficePhoneNumber = 'officeNumber',
  OfficePhoneNumberExtn = 'officeNumberExtn',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  RegionUuid = 'globalBrokerageRegionUuid',
  PostalCode = 'postalCode',
  CountryUuid = 'CountryUuid',
  BrokerTitle = 'title',
}

export enum AddressType {
  Billing = 'billing',
  Shipping = 'shipping',
}

export enum CreateClaimField {
  Description = 'description',
  DiscoveryDate = 'discoveryDate',
  DueDate = 'dueDate',
  JiraId = 'jiraId',
  PolicyUuid = 'policyUuid',
  ReferenceId = 'referenceId',
  ReportedDate = 'reportedDate',
  StartDate = 'startDate',
  Status = 'status',
  coverageLetter = 'Coverage under the Policy',
  documentLink = 'document Link',
}

export enum CreateMidtermFiled {
  midtermTransaction = 'midterm Transaction',
}

export enum CreateMidtermTransactionField {
  cancellationType = 'cancellationType',
  refundType = 'refundType',
  startDate = 'startDate',
  notes = 'notes',
  LegalName = 'legalName',
  DateOfAcquisition = 'dateOfAcquisition',
  NewBrokerUuid = 'newBrokerUuid',
  NewBrokerName = 'newBrokerName',
  NewBrokerageName = 'newBrokerageName',
  NewBrokerageAddress = 'newBrokerageAddress',
  NewBrokerageUuid = 'newBrokerageUuid',
}

export enum CreateReserveField {
  ClaimUuid = 'claimUuid',
  CoverageUuid = 'coverageUuid',
  ReserveTypeUuid = 'reserveTypeUuid',
  ReserveUuid = 'reserveUuid',
  ServiceUuid = 'serviceUuid',
  VendorUuid = 'vendorUuid',
  BudgetType = 'budgetType',
  Budget = 'budget',
  BudgetMin = 'budgetMin',
  BudgetMax = 'budgetMax',
}

export enum CreateReservePaymentField {
  Amount = 'amount',
  InvoiceDate = 'invoiceDate',
  InvoiceReference = 'invoiceNumber',
  PaymentDate = 'paymentDate',
  PaymentUuid = 'paymentUuid',
  Type = 'type',
}

export enum CompanyDomain {
  Converge = 'convergeins.com',
}

export enum Company {
  Converge = 'Converge',
}

export const UNKNOWN_COMPANY_LOGO =
  'https://via.placeholder.com/120x64.png/FFFFFF/000000?text=%3F' as const;

export const PUBLIC_URL = process.env['PUBLIC_URL'] as string;

export const UNITED_STATES_OF_AMERICA_LABEL = 'United States of America';

export const isUnitedStatesOfAmericaLabel = (value?: string) =>
  value === UNITED_STATES_OF_AMERICA_LABEL;

export enum PopoverFieldType {
  TextBox = 'TextBox',
  DatePicker = 'DatePicker',
  DateRangePicker = 'DateRangePicker',
  Select = 'Select',
}
export enum DateRangeFilterInput {
  Start = 'start',
  End = 'end',
}

// Define the SubmissionNestedFilterInput enum

export enum SubmissionNestedFilterInput {
  Broker = 'agent',
  Brokerage = 'agency',
  Underwriter = 'underwriter',
  UnderwriterAssistant = 'underwriterAssistant',
  Insured = 'insured',
  Task = 'task',
  DigitalSource = 'tenant',
}

// Define the SubmissionFilterFieldNameType enum
export enum SubmissionFilterFieldNameType {
  SubmissionReference = 'submission uuid',
  Status = 'Status',
  DueDate = 'Due Date',
  ReceivedAt = 'Received at',
  Insured = 'Insured',
  PolicyType = 'Policy Type',
  SubmissionType = 'Submission Type',
  RenewalType = 'Renewal Type',
  BrokerGroup = 'Broker Group',
  BrokerContact = 'Broker Contact',
  Received = 'Received',
  Cleared = 'Cleared',
  Type = 'Policy Type',
  Broker = 'Broker',
  Brokerage = 'Brokerage',
  Underwriter = 'Underwriter',
  UnderwriterAssistant = 'Underwriter Assistant',
  Task = 'Renewal Task',
  Program = 'Program',
  Partner = 'Partner',
  DigitalSource = 'Digital Source',
}

export enum SubmissionFieldIdType {
  SubmissionReferenceId = 'referenceId',
  Type = 'type',
  InsuredName = 'name',
  PolicyType = 'policyType',
  InsuredRevenue = 'revenue',
  InsuredIndustrySector = 'industry',
  ProducerName = 'producerName',
  DueDate = 'dueDate',
  UnderWriter = 'underwriterName',
  CreatedDate = 'createdAt',
  CreatedBy = 'createdBy',
  ReceivedAt = 'receivedAt',
  LastModifiedDate = 'updatedAt',
  PolicyStartDate = 'policyStartDate',
  Status = 'status',
  Actions = 'actions',
  SubmissionId = 'uuid',
  ClearedAt = 'clearedAt',
  Product = 'product',
  Brokerage = 'agency',
  Broker = 'agent',
  Assistant = 'assistant',
  submissionType = 'renewal',
  RenewalType = 'renewalType',
  RenewalStatus = 'renewalStatus',
  ActionItem = 'actionItems',
  Task = 'task',
  Program = 'program',
  Partner = 'partner',
  DigitalSource = 'digitalSource',
}

export enum SubmissionFieldLabelType {
  SubmissionReferenceId = 'submission.referenceId',
  Type = 'submission.type',
  InsuredName = 'submission.entity.legalName',
  PolicyType = 'submission.policyType',
  InsuredRevenue = 'submission.entity.revenue',
  InsuredIndustrySector = 'submission.entity.industry',
  ProducerName = 'submission.producer.name',
  DueDate = 'submission.dueDate',
  CreatedDate = 'submission.createdAt',
  EffectiveDate = 'Effective',
  CreatedBy = 'submission.createdBy',
  LastModifiedDate = 'submission.updatedAt',
  Status = 'submission.status',
  Actions = 'submission.actions',
  ReceivedAt = 'submission.receivedAt',
  ClearedAt = 'submission.clearedAt',
  Brokerage = 'BROKERAGE',
  BrokerContact = 'BROKER',
  Product = 'submission.product',
  UnderWriter = 'submission.underwriter.name',
  Assistant = 'submission.assistant',
  RenewalType = 'submission.renewalType',
  RenewalStatus = 'submission.renewalStatus',
  ActionItem = 'submission.actionItem',
  DigitalSource = 'submission.tenant',
}

export enum TaskIdType {
  Label = 'label',
  Status = 'status',
  Owner = 'ownerEmail',
  DueDate = 'dueDate',
  CountDown = 'countDown',
  Note = 'note',
}

export enum TaskLabels {
  Label = 'task.label',
  Status = 'task.status',
  Owner = 'task.owner',
  DueDate = 'task.dueDate',
  CountDown = 'task.countDown',
  Note = 'task.note',
}

export enum DateFormatType {
  ISODateFormat = 'YYYY-MM-DD',
  USADateFormat = 'MM/DD/YYYY',
  USANewFormat = 'MM/DD/YYYY',
  USADateFormatFull = 'L',
  USADateFormatWithTime = 'LLLL',
  USADateFormatWithTimeAt = 'll [at] LT',
  USADateFormatWithTimeAndSecondsAt = 'll [at] LTS',
  USATimeWithSeconds = 'LTS',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SubmissionSortKeys {
  AgencyName = 'AGENCY_NAME',
  AgentFirstName = 'AGENT_FIRST_NAME',
  AgentLastName = 'AGENT_LAST_NAME',
  AssigneeAuthUsername = 'UNDERWRITER_AUTH_USERNAME',
  AssigneeFirstName = 'UNDERWRITER_FIRST_NAME',
  AssigneeLastName = 'UNDERWRITER_LAST_NAME',
  AssigneeUsername = 'UNDERWRITER_USERNAME',
  CreatedAt = 'CREATED_AT',
  PolicyStartDate = 'POLICY_START_DATE',
  Notes = 'NOTES',
  ReferenceId = 'REFERENCE_ID',
  Status = 'STATUS',
  Type = 'TYPE',
  Uuid = 'UUID',
  InsuredName = 'INSURED_NAME',
  ReceivedAt = 'RECEIVED_AT',
  DueDate = 'DUE_DATE',
  DigitalSource = 'TENANT',
}

export enum EntityRiskProfileTypeId {
  Domains = 'Domains',
  IpAddress = 'IPAddress',
  OpenPorts = 'OpenPorts',
  Vulnerabilities = 'Vulnerabilities',
}

export enum EntityRiskProfileTypeLabel {
  Domains = 'Domains',
  IpAddress = 'IP addresses',
  OpenPorts = 'Open ports',
  Vulnerabilities = 'Vulnerabilities',
}

export enum EntitiesDomainFieldIdType {
  Domain = 'domain',
  DKIM = 'dkim',
  SPF = 'spf',
  Subdomains = 'subdomains',
  Risk = 'risk',
}

export enum EntitiesDomainFieldLabelType {
  Domain = 'Name',
  DKIM = 'DKIM',
  SPF = 'SPF',
  Subdomains = 'Subdomains',
  Risk = 'Risk',
}

export enum EntitiesSubdomainFieldIdType {
  Subdomain = 'name',
  DMARC = 'dmarc',
}

export enum EntitiesSubdomainFieldLabelType {
  Subdomain = 'Subdomain',
  DMARC = 'DMARC',
}

export enum EntitiesIpAddressesFieldIdType {
  IPAddress = 'ipv4Address',
  Version = 'version',
  OpenPorts = 'openPorts',
  Vulnerabilities = 'vulnerabilities',
  Risk = 'risk',
}

export enum EntitiesIpAddressesFieldLabelType {
  IPAddress = 'IP address',
  Version = 'Version',
  OpenPorts = 'Open ports',
  Vulnerabilities = 'Vulnerabilities',
  Risk = 'Risk',
}

export enum EntitiesOpenPortsFieldIdType {
  IPAddresses = 'ipAddresses',
  Protocol = 'protocol',
  Port = 'port',
  Source = 'source',
}

export enum EntitiesOpenPortsFieldLabelType {
  IPAddresses = 'IP addresses',
  Protocol = 'Protocol',
  Port = 'Port',
  Source = 'Source',
}

export enum EntitiesVulnerabilitiesFieldIdType {
  Product = 'product',
  Part = 'part',
  Version = 'version',
  Update = 'update',
  Edition = 'edition',
  Language = 'language',
  Type = 'type',
  CVE = 'cve',
  CWE = 'cwe',
  PublishDate = 'publishDate',
  UpdateDate = 'updateDate',
  Score = 'score',
  Access = 'access',
  Complexity = 'complexity',
  Authentication = 'authentication',
  Conf = 'conf',
  Integ = 'integ',
  Source = 'source',
  Cvss = 'CVSS',
  MoreInfo = 'More information',
  IpAddresses = 'IP addresses',
}

export enum EntitiesVulnerabilitiesFieldLabelType {
  Product = 'Product',
  Part = 'Part',
  Version = 'Version',
  Update = 'Update',
  Edition = 'Edition',
  Language = 'Language',
  Type = 'Type',
  CVE = 'CVE',
  CWE = 'CWE',
  PublishDate = 'PublishDate',
  UpdateDate = 'UpdateDate',
  Score = 'Score',
  Access = 'Access',
  Complexity = 'Complexity',
  Authentication = 'Authentication',
  Conf = 'CONF',
  Integ = 'INTEG',
  Source = 'Source',
  Cvss = 'CVSS',
  MoreInfo = 'More information',
  IpAddresses = 'IP addresses',
}

export enum EntitiesSoftwaresFieldIdType {
  Edition = 'edition',
  Language = 'language',
  Part = 'part',
  Product = 'product',
  Type = 'type',
  Update = 'update',
  Version = 'version',
  Source = 'source',
  Score = 'score',
}

export enum EntitiesSoftwaresFieldLabelType {
  Edition = 'Edition',
  Language = 'Language',
  Part = 'Part',
  Product = 'Product',
  Type = 'Type',
  Update = 'Update',
  Version = 'Version',
  Source = 'Source',
  Score = 'Score',
}

export enum EntitiesVulnerabilitiesCVEFieldIdType {
  CVEId = 'cveId',
  Product = 'Product',
  Part = 'Part',
  Version = 'Version',
  Update = 'Update',
  Edition = 'Edition',
  Language = 'Language',
  Type = 'Type',
}

export enum EntitiesVulnerabilitiesCVEFieldLabelType {
  CVEId = 'CVE ID',
  Product = 'Product',
  Part = 'Part',
  Version = 'Version',
  Update = 'Update',
  Edition = 'Edition',
  Language = 'Language',
  Type = 'Type',
}

export enum CompanyType {
  Private = 'Private',
  Public = 'Public',
}

export enum OFACClearanceType {
  Yes = 'Yes',
  No = 'No',
}

export enum UnderWritingSubmissionMenuType {
  Questionnaire = 'questionnaire',
}

export enum FilterIconType {
  OutLinedFilterIcon = 'outLinedFilterIcon',
  FilledFilterIcon = 'filledFilterIcon',
}

export const richTextEditorModules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
    ['link', 'image', 'video'],
    ['clean'],
  ],
};

export enum UnderwritingEnterpriseFusionScoreType {
  CentralizedPoliciesProcedures = 'Centralized policies & procedures',
  FinancialConditions = 'Financial conditions',
  NatureofOperations = 'Nature of operations',
  QualityofServiceProviderContracts = 'Quality of service provider contracts',
  QualityofServiceProviders = 'Quality of service providers',
  InvestmentInRiskManagement = 'Investment in risk management',
  ClaimsExperienceLastThreeYears = 'Claims experience last 3 years',
  UnusualRegulatoryScrutiny = 'Unusual regulatory scrutiny',
  RiskAssociatedWithBusinessLocations = 'Risk associated with business locations',
  CoverageVarianceFromBasePolicy = 'Coverage variance from base policy',
}

export enum UnderwritingEnterpriseFusionScoreTypeId {
  CentralizedPoliciesProcedures = 'CentralizedPoliciesProcedures',
  FinancialConditions = 'FinancialConditions',
  NatureofOperations = 'NatureofOperations',
  QualityofServiceProviderContracts = 'QualityofServiceProviderContracts',
  QualityofServiceProviders = 'QualityofServiceProviders',
  InvestmentInRiskManagement = 'InvestmentInRiskManagement',
  ClaimsExperienceLastThreeYears = 'ClaimsExperienceLastThreeYears',
  UnusualRegulatoryScrutiny = 'UnusualRegulatoryScrutiny',
  RiskAssociatedWithBusinessLocations = 'RiskAssociatedWithBusinessLocations',
  CoverageVarianceFromBasePolicy = 'CoverageVarianceFromBasePolicy',
}

export enum RiskLevelType {
  VeryLow = 'Very Low',
  Low = 'Low',
  Moderate = 'Moderate',
  High = 'High',
  VeryHigh = 'Very High',
}

export const RISK_LEVEL_TYPE_DEFAULT = RiskLevelType.Moderate;

export enum UnderwritingScheduleRatingType {
  AdditionalInsureds = 'Additional insureds',
  YearsInBusiness = 'Years in business',
  TerritoryOfOperations = 'Territory of operations',
  OrganizationalSohistication = 'Organizational sophistication',
  SignificantTermsAndConditions = 'Significant terms and conditions',
}

export enum UnderwritingScheduleRatingTypeId {
  AdditionalInsureds = 'AdditionalInsureds',
  YearsInBusiness = 'YearsInBusiness',
  TerritoryOfOperations = 'TerritoryOfOperations',
  OrganizationalSohistication = 'OrganizationalSohistication',
  SignificantTermsAndConditions = 'SignificantTermsAndConditions',
}

export const COVERAGE_TYPE_LABELS: Record<string, string> = {
  first_party: 'First party coverage',
  first_party_loss: 'First party loss of business income coverage',
  liability: 'Claims made liability coverage',
};

export enum AttachmentDataSource {
  sharepoint = 'https://convergeins.sharepoint.com',
  default = 'default',
}

export enum InsuredEntityFieldIdType {
  ReferenceId = 'referenceId',
  LegalName = 'name',
  Address = 'address',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Revenue = 'revenue',
  NaicsCode = 'naicsCode',
  IndustrySector = 'industrySector',
  DocumentsLink = 'documentsLink',
}

export enum CreateClaimFieldLabel {
  ReferenceId = 'Reference',
  Insured = 'Insured',
  Status = 'Status',
  DiscoveryDate = 'Discovery Date',
  ReportedDate = 'Reported Date',
  PolicyReferenceId = 'Policy Reference',
  DocumentsLink = 'documentsLink',
}

export enum InsuredPoliciesType {
  ReferenceId = 'policy reference',
  Type = 'type',
  Limit = 'Limit',
  Retention = 'Retention',
  Premium = 'netPremium',
  EffectiveDate = 'EffectiveDate',
  ExpirationDate = 'ExpirationDate',
  DocumentLink = 'DocumentLink',
}

export enum InsuredEntityFieldLabelType {
  ReferenceId = 'Insured Number',
  LegalName = 'Insured Name',
  Address = 'Insured Address',
  Revenue = 'Revenue',
  NaicsCode = 'Industry Sector',
  IndustrySector = 'Industry',
  Status = 'Status',
}

export enum BrokerAgenciesEntityFieldIdType {
  ReferenceId = 'referenceId',
  Name = 'name',
  BrokerLicenseNumber = 'brokerLicenseNumber',
  ActiveBrokersCount = 'activeBrokersCount',
  DefaultCommission = 'defaultCommission',
  AveragePremium = 'averagePremium',
  TotalSubmissions = 'totalSubmissions',
  TotalPremium = 'totalPremium',
  CommissionEarned = 'commissionEarned',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
}

export enum BrokerAgenciesEntityFieldLabelType {
  ReferenceId = 'Reference ID',
  Name = 'Name',
  BrokerLicenseNumber = 'License number',
  ActiveBrokersCount = 'Active brokers',
  DefaultCommission = 'Default commission',
  AveragePremium = 'Average premium',
  TotalSubmissions = 'Total submissions to date',
  TotalPremium = 'Total premium',
  CommissionEarned = 'Commission earned',
  CreatedAt = 'Created',
  UpdatedAt = 'Updated',
}

export enum PoliciesEntityFieldIdType {
  ReferenceId = 'referenceId',
  InsuredName = 'insuredName',
  InceptionDate = 'inceptionDate',
  EndDate = 'endDate',
  Premium = 'premium',
  Status = 'status',
  DocumentsLink = 'documentsLink',
}

export enum PoliciesEntityFieldLabelType {
  ReferenceId = 'Reference ID',
  InsuredName = 'Insured name',
  InceptionDate = 'Policy inception date',
  EndDate = 'Policy end date',
  Premium = 'Premium',
  Status = 'Status',
  DocumentsLink = 'Documents link',
}

export enum QuoteRetroactiveDateType {
  Coverage = 'Coverage',
  Endorsement = 'Endorsement',
}

export enum QuoteEntityFieldIdType {
  ReferenceId = 'referenceId',
  SubmissionRefID = 'submissionRefID',
  InsuredName = 'insuredName',
  BrokerName = 'brokerName',
  Premium = 'premium',
  Limit = 'limit',
  Retention = 'retention',
  Underwriter = 'underwriter',
  DocumentsLink = 'documentsLink',
  RatedPremium = 'ratedPremium',
  MinimumPremium = 'minimumPremium',
  QuotedPremium = 'quotedPremium',
  TechnicalPremium = 'technicalPremium',
  ModifiedCoveragePremium = 'modifiedCoveragePremium',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  SIR = 'SIR',
  Status = 'status',
}

export enum QuoteEntityFieldLabelType {
  ReferenceId = 'Reference ID',
  SubmissionRefID = 'Submission Ref ID',
  InsuredName = 'Insured Name',
  BrokerName = 'Broker Name',
  Premium = 'Premium',
  Limit = 'Limit',
  Retention = 'Retention',
  Underwriter = 'Underwriter',
  DocumentsLink = 'Documents Link',
  RatedPremium = 'RatedPremium',
  MinimumPremium = 'Minimum Premium',
  QuotedPremium = 'Quoted Premium',
  TechnicalPremium = 'Technical Premium',
  ModifiedCoveragePremium = 'Modified Coverage Premium',
  CreatedAt = 'Created',
  UpdatedAt = 'Updated',
  SIR = 'SIR',
  Status = 'Status',
}

export enum IQuoteStatus {
  Bound = 'BOUND',
  Draft = 'DRAFT',
  Quoted = 'QUOTED',
}

export const numberFieldMaxValue = 999999995;

export const NAICS_PLACEHOLDER_CODE = 99999;
export const NAICS_PLACEHOLDER_MESSAGE =
  'A valid NAICS code is required before this submission can be cleared ' +
  'or scored. Please update the Industry Sector (NAICS) field.';
